const pad = (value) => String(value).padStart(2, '0');

const parseLottoDateTime = (input) => {
  if (typeof input === 'number') return new Date(input * 1000);
  const normalized = input.replace(' ', 'T');
  return new Date(normalized);
};

export const toLottoMillis = (input) => {
  if (typeof input === 'number') return input * 1000;
  return new Date(input.replace(' ', 'T')).getTime();
};

export const formatLottoDate = (input) => {
  const date = parseLottoDateTime(input);
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  return `${year}-${month}-${day} ${hours}:${minutes}`;
};

export const parseDateArg = (input, endOfDay = false) => {
  if (!input) return null;
  const normalized = String(input).replace(' ', 'T');
  const date = new Date(normalized);
  if (Number.isNaN(date.getTime())) return null;
  if (endOfDay) {
    date.setHours(23, 59, 59, 999);
  }
  return date.getTime();
};

export const calcTimeDiffAndFormatToString = (targetMillis, shortFormat = false) => {
  const diff = targetMillis - Date.now();
  if (diff <= 0) return '00s';

  const totalSeconds = Math.floor(diff / 1000);
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (days > 0) {
    return shortFormat ? `${days}d ${pad(hours)}h` : `${days}d ${pad(hours)}h ${pad(minutes)}m`;
  }
  if (hours > 0) {
    return shortFormat ? `${hours}h ${pad(minutes)}m` : `${hours}h ${pad(minutes)}m ${pad(seconds)}s`;
  }
  if (minutes > 0) {
    return `${minutes}m ${pad(seconds)}s`;
  }
  return `${pad(seconds)}s`;
};
